import { isEmpty, isNil, isString } from 'lodash';
import { API } from '@shared/types/api';
import { STATIC_COMPONENT_IDS } from './staticComponentIds';
import type { Entity } from './types';

export type TitledEntity = Pick<API.WorkflowEntity, 'fields'> | Pick<Entity, 'allFields'>;

export type TitledWorkflowTemplate = Pick<API.WorkflowTemplate, 'referencingTitleComponentId'>;

/** Get the title of an entity without assuming fields.name */
export function getEntityTitle(
  entity?: TitledEntity | null,
  workflowTemplate?: TitledWorkflowTemplate,
): string | undefined {
  if (isNil(entity)) {
    return undefined;
  }
  const titleComponentId = getTitleComponentId(workflowTemplate);
  const value = getTitleValue(entity, titleComponentId);
  return isString(value) && !isEmpty(value) ? value : undefined;
}

export function getTitleComponentId(workflowTemplate?: TitledWorkflowTemplate): string {
  return workflowTemplate?.referencingTitleComponentId ?? STATIC_COMPONENT_IDS.NAME;
}

function getTitleValue(entity: TitledEntity, componentId: string): unknown {
  if ('allFields' in entity) {
    return entity.allFields.get(componentId)?.toDisplayString();
  } else {
    return entity.fields?.[componentId];
  }
}
